import { Component, OnInit, Inject, OnDestroy, ViewChildren, ViewChild, AfterViewInit, QueryList } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ManageRolesContext } from '../models/ManageRolesContext';
import { Store } from '@ngrx/store';
import { Actions } from '@ngrx/effects';
import { Observable, Subject } from 'rxjs';
import * as fromStore from '../store/reducers';
import * as actions from '../store/actions';
import { QueryAvailableRolesAction, QUERY_AVAILABLE_ROLES_SUCCESS, QUERY_AVAILABLE_ROLES_BY_TYPE_SUCCESS, QueryAvailableRolesByTypeAction } from '../store/actions/index';
import { SearchComponent } from '../../pillar/search/components/search.component';
import { AlertsComponent } from '../../pillar/alerts/components/alerts.component';
import { RoleModel } from '../models/RoleModel';
import { CurrentUserService } from '../services/CurrentUserService';

@Component({
  selector: 'brd-manage-roles-dialog',
  templateUrl: './manage-roles-dialog.component.html',
  styleUrls: ['./manage-roles-dialog.component.scss']
})
export class ManageRolesDialogComponent implements OnInit, OnDestroy {
  destroyed$: Subject<boolean> = new Subject<boolean>();
  loadingAvailable: boolean;
  availableRoles: RoleModel[];
  allRoles: RoleModel[] = [];
  allAssignedRoles: RoleModel[] = [];
  assignedRoles: RoleModel[];
  showDetailsForAvailable = true;
  showDetailsForAssigned = true;

  @ViewChild(AlertsComponent)
  alert: AlertsComponent;

  @ViewChildren(SearchComponent)
  searchs: QueryList<SearchComponent>;

  constructor(public store: Store<any>,
    private actions$: Actions,
    public dialogRef: MatDialogRef<ManageRolesDialogComponent>,
    private currentUserService: CurrentUserService,
    @Inject(MAT_DIALOG_DATA) public data: ManageRolesContext) {
    this.loadingAvailable = true;
    if (!data.roleType) {
      store.dispatch(new QueryAvailableRolesAction({
        page: 0,
        pageSize: 100
      }));
    } else {

      store.dispatch(new QueryAvailableRolesByTypeAction(data.roleType, {
        page: 0,
        pageSize: 100
      }));
    }
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
  }

  ngOnInit() {
    this.actions$
      .ofType(QUERY_AVAILABLE_ROLES_SUCCESS)
      .takeUntil(this.destroyed$)
      .subscribe(() => {
        this.loadingAvailable = false;
      });
    this.actions$
      .ofType(QUERY_AVAILABLE_ROLES_BY_TYPE_SUCCESS)
      .takeUntil(this.destroyed$)
      .subscribe(() => {
        this.loadingAvailable = false;
      });

    this.actions$.ofType(actions.MANAGE_ROLE_ERROR)
      .takeUntil(this.destroyed$)
      .subscribe((a: actions.ManageRoleErrorAction) => {
        a.payload.errors.forEach(e => this.alert.addError(e));
      });
    
    this.store.select(fromStore.getAvailableRoles).takeUntil(this.destroyed$)
      .subscribe((roles: RoleModel[]) => {
        this.allRoles = roles;
        this.updateAvailableRoles();
      });

    this.data.assignedRoles$.takeUntil(this.destroyed$)
      .subscribe((roles: RoleModel[]) => {
        this.allAssignedRoles = roles;
        this.updateAssignedRoles(null);
        this.updateAvailableRoles();
      });
  }

  ngAfterViewInit() {
    this.searchs.first.searchControl.valueChanges
      .takeUntil(this.destroyed$)
      .subscribe(() => {
        this.loadingAvailable = true;
        this.store.dispatch(new QueryAvailableRolesAction({
          page: 0,
          pageSize: 100,
          searchTerm: this.searchs.first.searchControl.value
        }));
      });
    this.searchs.last.searchControl.valueChanges
      .takeUntil(this.destroyed$)
      .subscribe(() => {
        this.updateAssignedRoles(this.searchs.last.searchControl.value);
      });
  }

  private updateAvailableRoles(): void {
    if (this.allRoles) {
      this.availableRoles = this.allAssignedRoles ? this.allRoles.filter(r => this.allAssignedRoles.find(ar => ar.key === r.key) == null &&
        (this.data.forRole === undefined || this.data.forRole.key !== r.key)) : this.allRoles;
    } else {
      this.availableRoles = undefined;
    }
  }

  private updateAssignedRoles(searchTerm) {
    this.assignedRoles = searchTerm ? this.allAssignedRoles.filter(ar => ar.name.toLowerCase().includes(searchTerm.toLowerCase())) : this.allAssignedRoles;
  }

  close() {
    this.dialogRef.close();
  }

  removeTheRole(role): void {
    if (this.allAssignedRoles.length === 1 && this.currentUserService.userContext.userName === this.data.accountName) {
      this.alert.addError("Cannot remove all roles.");
    } else {
      this.data.removeRole(role);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/security/components/manage-roles-dialog.component.ts